{
    "FormEngineSetterWfl": {
        "title": "Zuweisung",
        "description": "Setzt lokale Variablen und Formfelder"
    },
    "mask": {
        "FormEngineSetterWfl": {
            "groupTitle": "Zuweisung",
            "assignments": "Werte"
        }
    }
}